import axios, { AxiosInstance } from 'axios'

export default class HttpClient {
  private client: AxiosInstance
  private token: string = localStorage.getItem('@TMovFrotista:token')

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    })
  }

  public api(): AxiosInstance {
    return this.client
  }
}
